import classNames from "classnames";

type FormErrorSummaryProps = {
  hasError: boolean;
  message?: string;
};

// A single, always-mounted role="alert" region at the top of the form.
// Per-field errors stay associated to their field via aria-describedby
// (read when that field gets focus) but no longer carry their own
// role="alert" — having both meant screen readers announced the same
// message twice, and a field-level message like "Detta fält måste fyllas
// i" is meaningless once the user has moved on and can't see which field
// it was. This region announces once, on submit, that the form has
// errors — always present in the DOM (not conditionally mounted) so
// screen readers pick up the change instead of missing content that
// appears in the same instant as the region itself.
const FormErrorSummary = ({
  hasError,
  message = "Formuläret innehåller fel. Kontrollera de markerade fälten.",
}: FormErrorSummaryProps) => (
  <div
    role="alert"
    className={classNames(
      hasError && "text-red-700 dark:text-static-white border-2 border-red-500 p-3 mb-4 font-semibold",
    )}
  >
    {hasError && message}
  </div>
);

export default FormErrorSummary;
